import { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useUser } from '../../contexts/UserContext';
import useSettings from '../../hooks/useSettings';
import { Child } from '../../types';


const ChildrenTabs = ({ onTabChange }: { onTabChange: (child: Child) => void }) => {
    const { user } = useUser();
    const [selectedTab, setSelectedTab] = useState(0);
    const { textColor } = useSettings();

    useEffect(() => {
        if (user && user.children.length > 0 && onTabChange) {
            user.children.sort((a, b) => new Date(a.dob).getTime() - new Date(b.dob).getTime());
            onTabChange(user.children[0]);
        }
    }, []);

    const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        if (user && user.children[newValue]) {
            onTabChange(user.children[newValue]);
        }
    };

    return (
        <Tabs value={selectedTab} onChange={handleChange} aria-label="Children Tabs" className="children-tabs"
            variant="scrollable"
            TabIndicatorProps={{
                style: {
                    backgroundColor: textColor != '#FFFFFF' ? textColor : '#29AAE1'
                }
            }}
        >
            {user && user.children.map((child, index) => (
                <Tab label={`${child.fname} ${child.lname}`} key={index} />
            ))}
        </Tabs>
    );
};

export default ChildrenTabs;
